import { Observable } from 'rxjs';
import { 
  ContratoSplitEntity, 
  ContratoSplitCompleto, 
  VersionSplitEntity,
  EventoTrazabilidadEntity,
  ParticipanteDirectorioEntity,
  ColaboradorSplitEntity,
  CatalogosSplitsMml,
  CambioCampoSplit
} from '../models/splits.model';

export interface ExtraMetadataVersionSplit {
  archivoUrl?: string;
  storageKey?: string;
  nombreArchivo?: string;
  tamanoBytes?: number;
  idArchivoCola?: string;
  pendienteSubidaS3?: boolean;
  cambios?: CambioCampoSplit[];
}

export abstract class SplitsRepository {
  abstract getContratos(incluirEliminados?: boolean): Observable<ContratoSplitEntity[]>;
  abstract getContratoCompleto(id: string): Observable<ContratoSplitCompleto | undefined>;
  abstract saveContratoCompleto(agregado: ContratoSplitCompleto): Promise<string>;
  abstract deleteContrato(id: string): Promise<void>;
  abstract restoreContrato(id: string): Promise<void>;
  abstract duplicateContrato(id: string, nuevoTitulo: string): Promise<string>;
  abstract createVersionSnapshot(
    contratoId: string, 
    markdown: string, 
    autor: string, 
    motivo: string,
    extraMeta?: ExtraMetadataVersionSplit
  ): Promise<VersionSplitEntity>;
  abstract getVersiones(contratoId: string): Observable<VersionSplitEntity[]>;
  abstract registrarEventoTrazabilidad(evento: EventoTrazabilidadEntity): Promise<void>;
  abstract getEventosTrazabilidad(contratoId: string): Observable<EventoTrazabilidadEntity[]>;
  abstract getDirectorioParticipantes(): Observable<ParticipanteDirectorioEntity[]>;
  abstract getTodosColaboradoresActivos(): Observable<ColaboradorSplitEntity[]>;
  abstract upsertParticipantesDirectorio(items: ParticipanteDirectorioEntity[]): Promise<{ nuevos: number; actualizados: number }>;
  abstract eliminarParticipanteDirectorio(id: string): Promise<void>;
  getCatalogos?(): Observable<CatalogosSplitsMml>;
  buscarParticipanteExternoPorDocumento?(numeroDocumento: string): Promise<{
    encontrado: boolean;
    fuente?: string;
    participante: ParticipanteDirectorioEntity | null;
  }>;
}
